<template>
  <div v-if="product">
    <ul
      class="donation-widget"
      v-for="donationtype in product.donationtypes"
      v-show="type == donationtype"
      :key="donationtype"
    >
      <li
        class="dollar-handle-container"
        v-for="(handle, index) in product.dollarhandles[donationtype]"
        :key="index"
        :class="{ 'active': handle.amount == dollarhandle }"
      >
        <div class="selector">
          <label>
            <input
              :disabled="(formWizardCurrentStep != 0)"
              type="radio"
              v-model="dollarhandle"
              :name="'handle-widget-' + donationtype"
              :value="handle.amount"
            />

            <span class="amount">
              ${{ parseInt(handle.amount) }}
            </span>
          </label>
          
          <span class="selector-image" :style="'background-image: url('+ handle.img +')'"></span>
        </div>

        <div class="description">
          <h4>
            <span @click="updateDollarHandle(handle.amount)">{{ handle.header }}</span>
          </h4>
          <p>{{ handle.text }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  name: "DonationWidget",

  computed: {
    formWizardCurrentStep() {
      return this.$store.getters.donation.formWizardCurrentStep;
    },
    dollarhandle: {
      get() {
        return this.$store.getters.donation.dollarhandle;
      },
      set(value) {
        this.amount = value == "custom" ? null : value;
        this.$store.commit("updateDonation", { field: "dollarhandle", value });
      },
    },
    type: {
      get() {
        return this.$store.getters.donation.type;
      },
      set(value) {
        this.$store.commit("updateDonation", { field: "type", value });
      },
    },
    amount: {
      get() {
        return this.$store.getters.donation.amount;
      },
      set(value) {
        this.$store.commit("updateDonation", { field: "amount", value });
      },
    },

    product() {
      return this.$store.getters.product;
    },
  },

  methods: {
    updateDollarHandle(value) {
      if (this.formWizardCurrentStep == 0) {
        this.dollarhandle = value;
      }
    }
  }
};
</script>

<style scoped>
.donation-widget {
  margin: 0;
  list-style: none;
}

.dollar-handle-container {
  display: flex;
  flex-direction: column;
  min-height: 100px;
  margin-bottom: 1rem;
}

.dollar-handle-container .selector {
  position: relative;
  display: flex;
  flex: 1;
  min-height: 100px;
  margin: 1rem 0;
  background: var(--wwfBlack);
}

.dollar-handle-container.active .selector {
  background: var(--wwfBlue);
}

.dollar-handle-container .selector label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  color: var(--wwfWhite);
}

.dollar-handle-container .selector .amount {
  font-family: "WWFRegular", sans-serif;
  font-size: 26px;
}

.dollar-handle-container .selector input[type="radio"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.dollar-handle-container .selector-image {
  width: 74%;
  margin: 3px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.dollar-handle-container .description {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dollar-handle-container .description h4 {
  margin: 0;
  font-family: "Lato",sans-serif;
  font-size: 1rem;
  font-weight: bold;
}

.dollar-handle-container h4 span {
  cursor: pointer;
}

.dollar-handle-container.active .description h4,
.dollar-handle-container.active .description p {
  color: var(--wwfBlue);
}

@media screen and (min-width: 640px) {
  .dollar-handle-container {
    flex-direction: row;
  }

  .dollar-handle-container .selector {
    min-width: 300px;
    margin: 0 1rem 0 0;
  }

  .dollar-handle-container .description {
    width: 70%;
  }
}
</style>


// WEBPACK FOOTER //
// DonationWidget.vue?0b1f5954